import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { isEmpty } from 'lodash'

import {
  READY_FOR_REVIEW,
  IN_PROGRESS,
  COLLECTING_EVIDENCE,
  COMPLETED,
  IGNORED,
} from '@/reducers/tasks/tasks.constants'
import { Drawer } from '@/components/drawer/Drawer'
import { CopyButton } from '@/components/buttons/CopyButton'
import { PromptFeedbackDrawer } from '@/components/inbox/drawers/prompt-feedback/PromptFeedbackDrawer'

export const PromptFeedbackTask = ({ handleUpdateTask, refetchTasks }) => {
  const location = useLocation()
  const { task } = useSelector((state) => state.tasks)
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)

  // Reset dirty state when task is cleared (e.g. after resolve) so the
  // Drawer doesn't show a stale "unsaved changes" warning on close
  useEffect(() => {
    if (isEmpty(task)) {
      setHasUnsavedChanges(false)
    }
  }, [task])

  const taskUrl = `${window.origin}${location.pathname}${location.search}`
  const isArchived = ![READY_FOR_REVIEW, IN_PROGRESS, COLLECTING_EVIDENCE].includes(task?.status)
  const dataTestId = `task-drawer-card-${task?.id}`

  return (
    <Drawer
      id={task?.id || 'empty-task'}
      extraWide
      expandable
      warnOnClose={hasUnsavedChanges}
      title={
        <div className="flex-align-center medium-gap" data-testid={`${dataTestId}-drawer-title`}>
          Calibration
          <CopyButton content={taskUrl} name="Link" />
        </div>
      }
    >
      {(handleClose, { expanded } = {}) =>
        isEmpty(task) ? (
          <div>No task available.</div>
        ) : (
          <PromptFeedbackDrawer
            handleClose={handleClose}
            expanded={expanded}
            refetchTasks={refetchTasks}
            taskIsOpen={!isArchived}
            handlePrimaryAction={(taskId) => {
              if (isArchived) {
                handleUpdateTask(taskId, task.organization_id, READY_FOR_REVIEW, handleClose)
              } else {
                handleUpdateTask(taskId, task.organization_id, COMPLETED, handleClose)
              }
            }}
            handleSecondaryAction={
              isArchived
                ? null
                : (taskId) => {
                    handleUpdateTask(taskId, task.organization_id, IGNORED, handleClose)
                  }
            }
            primaryActionButtonText={isArchived ? 'Reopen' : 'Mark as Resolved'}
            secondaryActionButtonText={isArchived ? null : 'Mark as Dismissed'}
            onDirtyChange={setHasUnsavedChanges}
          />
        )
      }
    </Drawer>
  )
}
